const LeadNavigation = (($) => {

    const ELEMENT_VALUES = {'de': 'Interessentenanfragen', 'en': 'My Leads'};
    const DATA_IDENTIFIER = '.icon-lead__counter';

    $(document).ready(() => {
        let lang = document.documentElement.lang
        let badge = $(DATA_IDENTIFIER).prop('outerHTML');
        let naviItem = $(".flyout__link:contains('" + ELEMENT_VALUES[lang] + "')")

        if (naviItem.length < 1) return;

        naviItem.addClass('flyout__link--hasBadge')
        naviItem.append(badge);
    });

    return LeadNavigation;


})(jQuery);

// export default LeadNavigation
